import { render, staticRenderFns } from "./SettingsConfiguration.vue?vue&type=template&id=6c0a1db0&lang=true"
import script from "./SettingsConfiguration.vue?vue&type=script&lang=js"
export * from "./SettingsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports